<template>
    <el-dialog
        title="购入设备预算详情"
        :visible.sync="visible"
        width="85%"
        :before-close="beforeClose"
        :close-on-click-modal="false"
        custom-class="add-device-info-dialog"
    >
        <el-form
            ref="formId"
            :rules="rules"
            :model="saveDeviceFrom"
            class="bm bm-ver form-info-add"
            label-position="right"
            size="small"
            label-width="90px"
        >
            <div class="bm bm-ver deviceBox">
                <el-row :gutter="10" class="bm-ac dept-info">
                    <el-col :span="12" class="bm bm-ps bm-ac">
                        <el-form-item
                            label="部门"
                            label-width="60px"
                            v-if="saveDeviceFrom.list[0]"
                            :prop="`list.0.requestDepartName`"
                            :rules="{required: true,validator: checkDept,trigger: 'change'}"
                        >
                            <el-input
                                size="small"
                                v-model="saveDeviceFrom.list[0].requestDepartName"
                                clearable
                                placeholder="请输入部门"
                                :disabled="true"
                            ></el-input>
                        </el-form-item>
                    </el-col>
					<el-col :span="12" class="bm bm-pe bm-ac">
						<div class="total">
							合计： <span class="price">{{total}}</span>元
						</div>
					</el-col>
                </el-row>
                <div class="desc-info">
                    单价(元)为人民币金额。若为外币购买，需在详细说明处注明换算过程（外币金额及换算汇率），若未备注外币金额则执行时无法剔除汇兑影响
                </div>
                <div class="device-list">
                    <div
                        class="bm bm-ver device-list-row"
                        v-for="(item, index) in saveDeviceFrom.list"
                        :key="index"
                    >
                        <div class="bm bm-ac device-title">
                            <span class="device-name">{{item.deviceName}}</span>
                            <span class="device-model">型号：{{item.deviceModel}}</span>
							<span class="divider">|</span>
							<span class="device-model">历史参考价：{{money(item.referencePrice)}}元/{{item.baseMeasureUnit}}</span>
                        </div>
                        <div class="bm bm-ver device-info-row">
                            <!-- v2.0 -->
                            <div class="btn-del" @click="delDeviceRow(index)">删除</div>
                            <el-row :gutter="10" class="bm-ac sales-list-top">
                                <el-col :span="8" class="bm bm-ps bm-ac">
                                    <el-form-item
                                        label="到货期"
                                        :prop="`list.${index}.arrivalDate`"
                                        :rules="{required: true, message: '请选择到货期',trigger: 'change'}"
                                        style="width:100%"
                                    >
                                        <el-date-picker
                                            v-model="item.arrivalDate"
                                            type="date"
                                            placeholder="选择日期"
                                            style="width:100%"
                                            value-format="timestamp"
                                        ></el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="bm bm-ps">
                                    <el-form-item
                                        label="单价(元)"
                                        :prop="`list.${index}.price`"
                                        :rules="{required: true,message: '请输入单价',trigger: 'blur'}"
                                        style="width:100%"
                                    >
                                        <el-input
                                            v-model="item.price"
                                            :maxlength="12"
											type="number"
                                            size="small"
                                            clearable
											@input="item.price = onkeyNumber(item.price)"
                                            placeholder="请输入单价"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7" class="bm">
                                    <el-form-item label-width="32px">
                                        <div class="bm">
                                            <el-input-number
                                                v-model="item.quantity"
                                                @change="handleChange"
                                                :min="1"
                                                :max="100000000"
                                            ></el-input-number>
											<div>
												&nbsp;{{item.baseMeasureUnit}}
											</div>
                                            <div
                                                class="bm price bm-ac bm-pc"
                                                v-if="item.price"
                                            >¥ {{money(item.price*item.quantity)}}
											</div>
                                            <div class="bm price bm-ac bm-pc" v-else>¥ 0</div>&nbsp;元
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <!-- <el-col :span="1" class="bm  ">
									<div class="del-btn bm-pc" @click="delDeviceRow(index)">删除</div>
                                </el-col>-->
                            </el-row>
                            <el-row :gutter="10" class="bm-ac sales-list-top">
                                <el-col :span="8" class="bm bm-ps bm-ac">
                                    <el-form-item label="驱动因素" style="width:100%">
                                        <el-select
                                            v-model="item.drivingFactor"
                                            style="width:100%"
                                            filterable
                                            placeholder="请选择驱动因素"
                                            clearable
                                            size="small"
                                        >
                                            <el-option
                                                v-for="val in drivingFactorList"
                                                :key="val.id"
                                                :label="val.name"
                                                :value="val.name"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="bm bm-ps bm-ac">
                                    <el-form-item label="需求项目" style="width:100%">
                                        <!-- <el-input
                                            v-model="item.projectName"
                                            size="small"
                                            clearable
                                            placeholder="请输入需求项目"
                                            :disabled="infinite"
                                        ></el-input> -->
										<el-select
                                            v-model="item.projectName"
                                            placeholder="请选择需求项目"
											filterable
											 style="width:100%"
											remote
											:remote-method="remoteMethod"
											@change="(data)=>projectChange(data,index)"
                                            :disabled="infinite"
											popper-class="pn-select-style">
                                            <el-row class="title-select-option">
                                                <el-col :span="6">项目名称</el-col>
                                                <el-col :span="6">项目类型</el-col>
                                                <el-col :span="6">项目部门</el-col>
                                                <el-col :span="6">项目负责人</el-col>
                                            </el-row>
											<div class="option-list" @scroll.passive="getScroll($event)">
												<el-option
													v-for="(it, index) in projectList"
													:key="index"
													:label="it.projectName"
													:value="JSON.stringify(it)">
													<el-row class="option-select-option">
														<el-col :span="6" :title="it.projectName">{{it.projectName}}</el-col>
														<el-col :span="6">{{getProjectTypeVal(it.projectType)}}</el-col>
														<el-col :span="6">{{it.departName}}</el-col>
														<el-col :span="6">{{it.managerName}}</el-col>
													</el-row>
												</el-option>
												<div class="signText" v-show="selectloading">加载中...</div>
												<div class="signText" v-show="selectFinish">----嘿嘿，我可是有底线的----</div>
											</div>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="10">
                                <el-col>
                                    <el-form-item label="详细说明">
                                        <el-input type="textarea" v-model="item.description" maxlength="500" show-word-limit placeholder="请输入" :rows="3"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
                <div class="add-device bm bm-ac" @click="addNewDevice">+ 添加购入设备</div>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="beforeClose">取 消</el-button>
            <el-button type="primary" @click="temporaryData(1)" :disabled="isDisable">确 定</el-button>
        </div>
        <!-- 选择购入设备 -->
        <choose-devices
            :infinite="true"
            :section="addInnerDialog.devicesEmpty"
            :showDialog="addInnerDialog.showDevice"
            @openAddDevice="openAddDevice"
            @cannel="devicesInnerCancel"
            @callback="devicesInnerConfirm"
            @closeDevices="closeDevices"
        ></choose-devices>
        <!-- 增加新设备 -->
        <add-new-device
            :visible="addInnerDialog.addNewDeviceShow"
            @newDeviceConfirm="newDeviceConfirm"
            @newDeviceCancel="newDeviceCancel"
        ></add-new-device>
    </el-dialog>
</template>
<script>
// const R = require('ramda');
import { deviceApi } from "@/services";
import $money from "@/utils/money.js"
export default {
    props: {
        infinite: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            required: true
        },
        saveDeviceFrom: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            //校验规则
            isDisable: false,
            rules: {},
            addInnerDialog: {
				showDevice: false,
				//标记已选值
				devices: [],
				//每次进入都是重新选择，不记录已选值
                devicesEmpty: [],
                addNewDeviceShow: false
            },
            drivingFactorList: this.$store.state.init.configInfo.drivingFactorList,
			oldList: [],
			projectList: [],
			pageNo: 1,
			pageSize: 10,
			selectloading: false,
			selectFinish: false,
			remoteValue: "", // 远程搜索值
			total:0
        };
    },
    mounted() {
        // 深度拷贝
		this.oldList = JSON.parse(JSON.stringify(this.saveDeviceFrom.list));
		this.getProjectList()
    },
    watch: {
        saveDeviceFrom: {
            handler: function(newValue, oldValue) {
                if (newValue.list.length != 0) {
                    this.oldList = JSON.parse(
                        JSON.stringify(this.saveDeviceFrom.list)
					);
                }
            },
            immediate: true,
            deep: true
		},
		oldList:{
            handler: function(newValue, oldValue) {
                if (newValue.length != 0) {
					this.total = 0
                    newValue.map((v)=>{
						this.total += v.price*v.quantity
					})
					this.total = $money(this.total,2,'')
                }
            },
            immediate: true,
            deep: true
		},
    },
    methods: {
		money(data){
			let num = $money(data,2,'')
			// this.$forceUpdate()
			return num
		},
		onkeyNumber(obj){
   		 	obj = obj.replace(/[^\d.]/g,""); //清除"数字"和"."以外的字符
        	obj = obj.replace(/^\./g,""); //验证第一个字符是数字而不是
        	obj = obj.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的
       	 	obj = obj.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
       	 	obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3'); //只能输入两个小数  
			return obj
		},
		getScroll(event){
			let scrollBottom =
				event.target.scrollHeight -
				event.target.scrollTop -
				event.target.clientHeight;
			if ( scrollBottom < 100 && !this.selectloading && !this.selectFinish) {
				this.selectloading = true
				this.pageNo++
				this.getProjectList().then(res => {
					this.selectloading = false
					if (res.responseData.totalPages == this.pageNo) {
						this.selectFinish = true
					}
				})
			}
		},
		// v2.0 获取列表
		getProjectList(){
			let param = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                userCode: this.$store.state.init.initData.fillPersonCode,
                projectType:"",
                status:"",
                projectKeyword: this.remoteValue, // 编码名称 模糊搜索
                managerName:"",
                departName:"",
                productName:"",
                customerName:"",
                projectModeList:[],
                baseFormList:[],
                currentProgressList:[],
                researchTypeList:[],
                aidTypeList:[],
                secondaryTypeList:[],
                accessTypeList:[],
                sortColumn:"",
                sortDirection:""
            }
			return deviceApi.getProjectList(param).then(res => {
				this.projectList = this.projectList.concat(res.responseData.list)
				return res
			})
		},
		// v2.0 搜索值改变事件
		remoteMethod(val){
			this.pageNo = 1
			this.projectList = []
			this.remoteValue = val
			this.selectFinish = false
			this.getProjectList()
		},
		// v2.0 枚举值获取
		getProjectTypeVal(key){
			let val = ""
			switch (key) {
				case "it":
					val = "IT类"
				case "researchAndDevelop":
					val = "研发类"
				case "medicalResearch":
					val = "医学研究"
				case "market":
					val = "市场类"
				case "engineer":
					val = "工程类"			
					break;
				default:
					val = "其他类"
					break;
			}
			return val
		},
        openAddDevice(e) {
            this.addInnerDialog.showDevice = false;
            this.addInnerDialog.addNewDeviceShow = true;
        },
        newDeviceCancel() {
            this.addInnerDialog.addNewDeviceShow = false; //添加 一条新设备
            this.addInnerDialog.showDevice = true; //添加 设备选择框
        },
        newDeviceConfirm(e) {
            this.addInnerDialog.devices.push({
                id: e.id ? e.id : "",
                requestDepartCode: this.oldList[0].requestDepartCode, //将部门信息插入设备选择
                requestDepartName: this.oldList[0].requestDepartName,
                managerName: this.$store.state.init.initData.fillPersonName, //姓名
                managerCode: this.$store.state.init.initData.fillPersonCode, //工号
                deviceCode: e.deviceCode.deviceCode,
                deviceName: e.deviceName,
                assetsKindCode: e.assetsKindCode,
                assetsKindName: e.assetsKindName,
                assetsTypeCode: e.assetsTypeCode,
				assetsTypeName: e.assetsTypeName,
				assetsSubTypeCode: e.assetsSubTypeCode,
                assetsSubTypeName: e.assetsSubTypeName,
                deviceModel: e.deviceModel,
                arrivalDate: R.isNil(e.arrivalDate) ? "" : e.arrivalDate,
                drivingFactor: e.drivingFactor,
                projectName: e.projectName
                    ? e.projectName
                    : this.saveDeviceFrom.projectName, //取当前项目名字
                projectCode: e.projectCode
                    ? e.projectCode
                    : this.saveDeviceFrom.projectCode, //取当前项目名字
                quantity: e.quantity ? e.quantity : 1,
                price: e.price ? e.price : "",
				amount: e.amount ? e.amount : 1,
				baseMeasureUnit:e.baseMeasureUnit,
				referencePrice:e.referencePrice,

            });
            this.addInnerDialog.addNewDeviceShow = false; //添加 一条新设备
            // this.addInnerDialog.showDevice = true; //添加 设备选择框
        },
        beforeClose() {
            this.$emit("temporaryData", { state: 0 });
        },
        //选择设备取消
        addNewDevice() {
            let that = this;
            this.addInnerDialog.devices = this.saveDeviceFrom.list;
            this.addInnerDialog.showDevice = true;
        },
        closeDevices() {
            this.addInnerDialog.showDevice = false;
        },
        devicesInnerCancel() {
            this.addInnerDialog.showDevice = false;
        },
        //选择设备确定
        devicesInnerConfirm(val) {
            console.log("val:", val);
            if (val.res.length > 0) {
				/*  v1.0代码
					// let oldList = this.saveDeviceFrom.list;
					this.saveDeviceFrom.list = [];
				*/ 
				// v2.0 确认 纯粹新增 不是替换 
				let oldList = this.saveDeviceFrom.list;
                console.log("oldList", this.oldList);
                val.res.forEach((value, key) => {
                    this.saveDeviceFrom.list.push({
                        requestDepartCode: this.oldList[0]
                            ? this.oldList[0].requestDepartCode
                            : "",
                        requestDepartName: this.oldList[0]
                            ? this.oldList[0].requestDepartName
                            : "",
                        managerName: this.$store.state.init.initData.personName, //姓名
                        managerCode: this.$store.state.init.initData.personCode, //工号
                        deviceCode: value.deviceCode,
                        deviceName: value.deviceName,
                        assetsKindCode: value.assetsKindCode,
                        assetsKindName: value.assetsKindName,
                        assetsSubTypeCode: value.assetsSubTypeCode,
                        assetsSubTypeName: value.assetsSubTypeName,
                        assetsTypeCode: value.assetsTypeCode,
                        assetsTypeName: value.assetsTypeName,
                        deviceModel: value.deviceModel,
                        arrivalDate: value.arrivalDate ? value.arrivalDate : "",
                        drivingFactor: value.drivingFactor,
                        projectName: value.projectName
                            ? value.projectName
                            : this.saveDeviceFrom.projectName, //取当前项目名字
                        projectCode: value.projectCode
                            ? value.projectCode
                            : this.saveDeviceFrom.projectCode, //取当前项目名字
                        quantity: value.quantity ? value.quantity : 1,
                        price: value.price ? value.price : "",
						amount: value.amount ? value.amount : 1,
						baseMeasureUnit:value.baseMeasureUnit,
						referencePrice:value.referencePrice,
                    });
                });
                this.addInnerDialog.showDevice = false;
                this.addInnerDialog.chooseDeptShow = true;
                this.addInnerDialog.devicesEmpty = [];
            }
        },
        checkDept(rule, value, callback) {
            let info = "";
            if (R.isNil(value) || R.isEmpty(value) || value.length == 0) {
                info = "请选择部门";
                return callback(new Error(info));
            } else {
                return callback();
            }
        },
        temporaryData(e) {
            let that = this;
            if (e) {
                this.$refs.formId.validate(state => {
                    if (state) {
                        that.isDisable = true;
                        setTimeout(function() {
                            that.isDisable = false;
                        }, 2000);
                        this.saveDeviceFrom.list.forEach((res, index) => {
                            res.price = parseFloat(res.price);
                            res.amount = res.price * res.quantity;
                            res.devicePurchaseFlag = 1;
                        });
                        that.$emit("temporaryData", { state: e });
                    }
                });
            } else {
                this.$emit("temporaryData", { state: e });
            }
        },
        handleChange(value) {
            console.log(value);
        },
        delDeviceRow(e) {
            console.log(e);
            // this.oldList = JSON.parse(JSON.stringify(this.saveDeviceFrom.list))
            console.log("oldList ", this.oldList);
            this.saveDeviceFrom.list.splice(e, 1);
        },
        handelClick(n) {
            switch (n) {
                case 0:
                    this.$emit("know");
                    break;
                case 1:
                    this.$emit("confirm");
                    break;
                default:
                    break;
            }
		},
		/* 3.0 */
		projectChange(data,index){
			let item = JSON.parse(data)
			this.saveDeviceFrom.list[index].projectName = item.projectName
			this.saveDeviceFrom.list[index].managerCodeList = []
			item.managerList.map((v)=>{
				this.saveDeviceFrom.list[index].managerCodeList.push(v.managerCode)
			})
		}
    }
};
</script>
<style lang="scss" scoped>
.form-info-add {
    // height: 100%;
    width: 100%;
    height: 400px;
    overflow-y: auto;

    .deviceBox {
        width: 99%;
		.total{
			height:32px;
			line-height: 32px;
			.price{
				font-size: 16px;
				font-weight: normal;
				letter-spacing: 2px;
				color: #ff3507;
			}
		}
    }
    .desc-info {
        font-size: 12px;
        color: #ff3507;
        margin-left: 20px;
        line-height:20px;
        margin-bottom: 17px;
    }
    .device-list {
        .device-list-row {
            margin-top: 30px;
            height: 230px;
        }
        .device-list-row:first-child {
            margin-top: 0px;
            height: 230px;
        }
    }
    .device-title {
        margin-left: 20px;
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 16px;
        color: #323232;
		.divider{
			margin-left: 9px;
			 color: #e6e6e6;
		}
        .device-model {
            font-size: 12px;
            color: #969696;
            margin-left: 9px;
            line-height: 12px;
        }
    }
    .add-device {
        margin-left: 20px;
        margin-top: 40px;
        font-size: 14px;
        line-height: 14px;
        color: #409eff;
		cursor: pointer;
		width: fit-content;
    }
    .device-info-row {
        border: solid 1px #dcdfe5;
        padding: 20px 20px 2px 20px;
        position: relative;
        .price {
            font-size: 14px;
            line-height: 14px;
            color: #ff3507;
            margin-left: 30px;
        }
        .btn-del {
            position: absolute;
            top: 0;
            right: 0;
            padding: 2px 5px;
            background-color: #ff3507;
            color: #ffffff;
            font-size: 12px;
        }
        .del-btn {
            height: 50px;
        }
    }
    .el-input--small .el-input__inner {
        height: 30px;
        line-height: 30px;
    }
    .el-input-number__increase,
    .el-input-number__decrease {
        top: 2px;
        height: 28px;
    }
}
</style>
<style lang="scss">
.el-dialog.add-device-info-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0 !important;
    transform: translate(-50%, -50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
    display: flex;
    flex-direction: column;
    .el-dialog__body {
        padding: 20px 20px;
        display: flex;
        align-items: center;
        height: auto;
        // overflow: auto;
    }
}
</style>
